import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";
import profile from "../../../images/log-veezzo-login.jpeg";

const NavHader = () => {
  const location = useLocation();
  const { navigationHader, background } = useContext(ThemeContext);
  
  if (location.pathname === "/pos") {
    return null;
  }

  return (
    <>
      <div className="nav-header">
        <Link className="brand-logo">
          <img
            src={profile}
            alt="Veezzo Logo"
            style={{ height: 50, width: 50, borderRadius: "8px", objectFit: "contain" }}
          />
        </Link>
      </div>

      <style>{`
        .nav-header {

          position: fixed !important;
          top: 0 !important;
          left: 0 !important;
          width: 70px !important;
          height: 50px !important;
          z-index: 1001 !important;
         
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          border-right: 1px solid rgba(186, 15, 48, 0.25) !important;
          box-shadow: 2px 0 8px rgba(186, 15, 48, 0.25) !important;
        }

        .brand-logo {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 100% !important;
          height: 100% !important;
          padding: 8px !important;
        }
      `}</style>
    </>
  );
};

export default NavHader;